import { NgModule, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import {LoginService} from "../../injections/login.service";
import {StatsService} from "../../injections/stats.service";
import {Router, ActivatedRoute, NavigationEnd} from "@angular/router";
import { Subscription } from 'rxjs/Subscription';
import { ModalPasswordService } from '../modal-password/modal-password.service';

@Component({
  selector:'nav-bar',
  templateUrl: './nav.html'
})
export class NavComponent implements OnInit{
    public selected: string;
    public logged: boolean = null;
    public subscription: Subscription;
    public managerUser;
    public statsMonth;
    public statsWeek;

    constructor(private loginService: LoginService, private _router: Router, private _activatedRoute: ActivatedRoute, private modalPassService: ModalPasswordService, private statsService: StatsService){
        this.logged = this.loginService.canActivate();
        this.managerUser = (this.logged) ? this.loginService.getUserManager() : {};
        this._router.events
        .filter(event => event instanceof NavigationEnd)
        .subscribe((event) => {
            var cleanUrl = event["url"].split("/");
            cleanUrl =  (cleanUrl[1] == "new-service" || cleanUrl[1] == "") ? "/services" : "/" + cleanUrl[1];
            this.selected = cleanUrl;
        });

        this.subscription = this.loginService.getIfLogged().subscribe(message => {this.setDataLogued(<boolean>message) });
    }
    public navChanged(child: string){
        this.selected = child;
    }

    public logOut(){
        this.loginService.logout();
    }

    public showModalPassword(){
        this.modalPassService.openModalPassword(this.managerUser);
    }

    public loadStats(){
        /*this.statsService.getHoursMonth().subscribe( result  => {
            this.statsMonth = result;
        });

        this.statsService.getHoursWeek().subscribe( result  => {
            this.statsWeek = result;
        });*/
    }

    public setDataLogued(message: boolean){
        this.logged = message;
        this.loadStats();
    }

    ngOnInit(){
        if(this.logged){
            this.loadStats();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/common/nav/nav.component.ts